<template>
  <AppLayout>
    <div class="container mt-4">

      <div class="row">
        <div class="col-12 col-lg-6 mb-3 text-start">
          <Link :href="route('kadry.lista')" class="btn btn-outline-primary me-3" style="width:200px;">
          <i class="bi bi-arrow-return-left"></i>&nbsp;Pracownicy
          </Link>
          <Link :href="route('kadry.urlopy.show.user', { user_id: this.userID })" class="btn btn-success"
            style="width:200px;">
          <i class="bi bi-person-vcard"></i>&nbsp;Dane urlopowe
          </Link>
        </div>

        <div class="col-12 col-lg-6 mb-3 text-end">
          <Link :href="route('kadry.karta.ewidencji.show', this.userID)" class="btn btn-outline-secondary me-4"
            style="width:280px;">
          <i class="bi bi-calendar-check"></i>&nbsp;Karta ewidencji czasu pracy
          </Link>
		   <Link :href="route('pracownik.godziny.zestawienie', this.userID)" class="btn btn-outline-secondary me-4">
          <i class="bi bi-clock"></i>&nbsp;Odbicia karty
          </Link>
		  <a :href="route('show.stopka.email', this.userID)" target="_blank" rel="noopener noreferrer"
			 class="btn btn-outline-info me-4">
			<i class="bi bi-envelope"></i>&nbsp;Stopka e-mail
		  </a>
		</div>
      </div>

      <div class="col-12 row d-flex align-items-stretch">

        <div class="col-md-6 mb-4 d-flex flex-column">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title w-100 d-flex justify-content-between align-items-center">
                <span>Dane pracownika</span>
                <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="plecMezczyzna" value="0" v-model="lokalnePlec">
                    <label class="form-check-label" for="plecMezczyzna">Mężczyzna</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="plecKobieta" value="1" v-model="lokalnePlec">
                    <label class="form-check-label" for="plecKobieta">Kobieta</label>
                  </div>
                </div>
              </h5>

              <div class="row">
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneImie">Imię:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneImie" class="form-control"
                    v-model="lokalneImie" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneNazwisko">Nazwisko:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneNazwisko" class="form-control"
                    v-model="lokalneNazwisko" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneKod">Kod pocztowy:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneKod" class="form-control"
                    v-model="lokalneKod" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneMiasto">Miejscowość:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneMiasto" class="form-control"
                    v-model="lokalneMiasto" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneUlica">Ulica:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneUlica" class="form-control"
                    v-model="lokalneUlica" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneNr">Nr budynku/mieszkania:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneNr" class="form-control"
                    v-model="lokalneNr" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneTelPr">Telefon prywatny:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneTelPr" class="form-control"
                    v-model="lokalneTelPr" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneTelFir">Telefon firmowy:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneTelFir" class="form-control"
                    v-model="lokalneTelFir" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneEmPr">E-mail prywatny:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneEmPr" class="form-control"
                    v-model="lokalneEmPr" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneEmFir">E-mail firmowy:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneEmFir" class="form-control"
                    v-model="lokalneEmFir" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="data_urodzenia">Data urodzenia:</label>
					<input v-model="lokalneDataUrodzenia" type="date" class="form-control" style="border-radius: 0;" />
                </div>	
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneMiejsceUrodzenia">Miejsce urodzenia:</label>
                  <input type="text" style="border-radius: 0;" id="lokalneMiejsceUrodzenia" class="form-control"
                    v-model="lokalneMiejsceUrodzenia" />
                </div>				
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="wyksztalcenie">Wykształcenie:</label>
                  <select class="form-select" id="wyksztalcenie" style="border-radius: 0;"
                    v-model="lokalneWyksztalcenie">
                    <option v-for="poziom in listaWyksztalcenia" :key="poziom" :value="poziom">{{ NaukaIdNaTekst(poziom)
                      }}</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="nauka">Zaliczyć wykształcenie jako staż pracy:</label>
                  <select class="form-select" id="nauka" style="border-radius: 0;" v-model="lokalneNauka">
                    <option value="0">Nie</option>
                    <option value="1">Tak</option>
                  </select>
                </div>				
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="inwalida">Orzeczenie o niepełnosprawności:</label>
                  <select class="form-select" id="inwalida" style="border-radius: 0;" v-model="lokalneInwalida">
                    <option value="0">Nie</option>
                    <option value="1">Znaczne</option>
                    <option value="2">Umiarkowane</option>
                    <option value="3">Lekkie</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="weteran">Weteran:</label>
                  <select class="form-select" id="weteran" style="border-radius: 0;" v-model="lokalneWeteran">
                    <option value="0">Nie</option>
                    <option value="1">Tak</option>
                  </select>
                </div>
			  </div>
              <div class="text-end mt-auto p-3">
                <button class="btn btn-primary btn-sm" @click="zapiszWszystko">Zapisz</button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="userDane?.wyksztalcenie !== null && userDane?.wyksztalcenie !== undefined && userDane?.wyksztalcenie !== ''"
          class="col-md-6 mb-4 d-flex flex-column">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column justify-content-start">
              <div class="row align-items-center">
                <div
                  class="col-12 col-lg-6 mb-3 mb-lg-0 d-flex flex-wrap align-items-center gap-2 text-lg-start text-center">
                  <h5 class="card-title mb-0 me-2">Dane zatrudnienia</h5>
                  <button @click="openModalStaze" class="btn btn-success btn-sm">
                    <i class="bi bi-plus-circle me-2"></i>Historia zatrudnienia
                  </button>
                </div>
                <div class="col-12 col-lg-6 text-lg-end text-center">
                  <label class="switch s-icons s-outline s-outline-success mb-0">
                    <input type="checkbox" v-model="lokalnyIsActive" @change="zapiszWszystko()">
                    <span class="slider round"></span>
                  </label>
                  <span class="ms-2">Umowa aktywna</span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-lg-6 mb-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label" for="lokalneUmowaOd">Umowa od:</label>
                    <span v-if="!lokalneUmowaOd" id="lokalneUmowaOd" class="text-warning"
                      title="Brak daty podpisania umowy o pracę.">⚠️</span>
                  </div>
                  <input v-model="lokalneUmowaOd" type="date" class="form-control" style="border-radius: 0;" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label" for="lokalneUmowaDo">Umowa do:</label>
                    <span v-if="showUmowaWarning" class="text-warning"
                      title="Umowa kończy się w mniej niż 30 dni">⚠️</span>
                  </div>
                  <input v-model="lokalneUmowaDo" type="date" class="form-control" style="border-radius: 0;" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="umowa_typ">Rodzaj umowy:</label>
                  <select class="form-select" id="umowa_typ" style="border-radius: 0;" v-model="lokalneUmowaTyp">
                    <option v-for="(umowa, umowaId) in typy_umow" :key="umowaId" :value="umowa.id">{{ umowa.nazwa }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="etat">Jaki etat:</label>
                  <select class="form-select" id="etat" style="border-radius: 0;" v-model="lokalneUserStaz">
                    <option v-for="(etaty, etatId) in typy_etaty" :key="etatId" :value="etaty.id">{{ etaty.nazwa }}
                    </option>
                  </select>
                </div>

                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="lokalnestanowisko">Stanowisko:</label>
                  <input type="text" style="border-radius: 0;" id="lokalnestanowisko" class="form-control"
                    v-model="lokalnestanowisko" />
                </div>
                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="lokalnestanowiskoEN">Stanowisko ENG:</label>
                  <input type="text" style="border-radius: 0;" id="lokalnestanowiskoEN" class="form-control"
                    v-model="lokalnestanowiskoEN" />
                </div>				
                <div class="col-md-6 col-lg-6 mb-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label" for="lokalneDataZUS">Data zgłoszenia w ZUS:</label>
                  </div>
                  <input v-model="lokalneDataZUS" type="date" class="form-control" style="border-radius: 0;" />
                </div>				
                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="dzial">Dział:</label>
                  <multiselect id="departments" v-model="lokalnedzial" :options="departamenty" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" placeholder="Wybierz departamenty" label="name"
                    track-by="id" tag-placeholder="Dodaj nowy" :taggable="true" @tag="addTag">
                  </multiselect>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="oddzial">Oddział:</label>
                  <select class="form-select" id="oddzial" style="border-radius: 0;" v-model="lokalneOddzial">
                    <option v-for="(oddz, oddzialID) in oddzialy" :key="oddzialID" :value="oddz.id">{{ oddz.nazwa }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="godziny">Godziny pracy:</label>
                  <select class="form-select" id="godziny" style="border-radius: 0;" v-model="lokalneGodziny">
                    <option v-for="(godzinyId, gid) in godziny_id" :key="gid" :value="godzinyId.id">{{ godzinyId.nazwa
                      }}</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneNrKarty">Numer karty: <span
                      v-if="lokalneNrKarty != Smart_nr_karty">(w SMART: <strong>{{ Smart_nr_karty
                        }}</strong>)</span></label>
                  <input type="text" style="border-radius: 0;" id="lokalneNrKarty" class="form-control"
                    v-model="lokalneNrKarty" />
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="smartdzial">Dział w SMART:</label>
                  <select class="form-select" id="smartdzial" style="border-radius: 0;"
                    v-model="lokalneSmartDepartmentID">
                    <option v-for="(smart_dzial, smartdzID) in smart_dzialy" :key="smartdzID"
                      :value="smart_dzial.ID_Department">{{ smart_dzial.DepartmentName }}</option>
                  </select>
                </div>

                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="smartup">Uprawnienie w SMART:</label>
                  <select class="form-select" id="smartup" style="border-radius: 0;" v-model="lokalneSmartPrivilageID">
                    <option v-for="(smart_uprawnienie, smartupID) in smart_uprawnienia" :key="smartupID"
                      :value="smart_uprawnienie.ID_Privilage">{{ smart_uprawnienie.Nazwa }}</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="smartup">Zaznacz żeby zapisać w SMART:</label><br>
                  <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                    <input id="saveSmart" type="checkbox" class="custom-control-input" :checked="saveSmart">
                    <label for="saveSmart" class="custom-control-label h6">Zapisz w SMART</label>
                  </div>
                </div>
              </div>
              <div class="text-end mt-auto p-3">
                <button class="btn btn-primary btn-sm" @click="zapiszWszystko">Zapisz</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="lokalneUmowaOd" class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column align-items-center justify-content-start">
              <h5 class="card-title w-100">Dane do urlopu</h5>
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Urlop przyznany na rok {{ selectedYear }}</span>
                          <span v-if="lokalneTenRok < 1" class="text-warning"
                            title="Brak dodanych dni urlopu na dany rok">⚠️</span>
                        </div>
                      </td>
                      <td>
                        <input v-model="lokalneTenRok" type="number" @keyup="save('ten_rok', lokalneTenRok)"
                          @change="save('ten_rok', lokalneTenRok)" class="form-control" style="border-radius: 0;" />
                      </td>
                    </tr>
                    <tr>
                      <td>Urlop z {{ selectedYear - 1 }} roku (dni)</td>
                      <td>
                        <input v-model="lokalnepoprzedniRok" type="number"
                          @keyup="save('poprzedni_rok', lokalnepoprzedniRok)"
                          @change="save('poprzedni_rok', lokalnepoprzedniRok)" class="form-control"
                          style="border-radius: 0;" />
                      </td>
                    </tr>
                    <tr>
                      <td>Wypoczynkowe dostępne</td>
                      <td>
                        <center>
                          <h4>{{ razemDniWolnych }}</h4>
                        </center>
                      </td>
                    </tr>
                    <tr>
                      <td>Wypoczynkowe wykorzystane</td>
                      <td>
                        <table style="width: 100%;">
                          <thead>
                            <tr>
                              <th style="width: 50%;">
                                <center>Wykorzystane</center>
                              </th>
                              <th style="width: 50%;">
                                <center>Pozostało</center>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="width: 50%;">
                                <center><strong>{{ wykorzystanychDniWolnych }}</strong></center>
                              </td>
                              <td style="width: 50%;">
                                <center><strong>{{ zostaloDniWolnych }}</strong></center>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr v-if="dzieciall.length && selectedYear === new Date().getFullYear()">
                      <td class="text-nowrap">
                        <span>Zgoda na urlop ojcowski</span>
                      </td>
                      <td>
                        <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                          <input type="checkbox" v-model="lokalneOjcowski" :true-value="1" :false-value="0"
                            @change="save('ojcowski', lokalneOjcowski)"><span class="slider round"></span></label>
                      </td>
                    </tr>
                    <tr v-if="dzieciall.length && selectedYear === new Date().getFullYear()">
                      <td class="text-nowrap">
                        <span>Zgoda na urlop rodzicielski</span>
                      </td>
                      <td>
                        <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                          <input type="checkbox" v-model="lokalneRodzicielski" :true-value="1" :false-value="0"
                            @change="save('rodzicielski', lokalneRodzicielski)"><span
                            class="slider round"></span></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-4 w-100">
                <h5 class="card-title">Daty urodzenia dzieci pracownika</h5>
                <button @click="addDziecko" class="btn btn-success btn-sm mb-2"><i
                    class="bi bi-plus-circle me-2"></i>Dodaj dziecko</button>

                <div v-if="dzieciall.length || dodajDziecko" class="table-responsive mb-2">
                  <table class="table table-bordered table-hover w-100">
                    <thead>
                      <tr>
                        <th>Data urodzenia dziecka</th>
                        <th>Urlop ojcowski</th>
                        <th>Urlop rodzicielski</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dziecko, index) in dzieciall" :key="index">
<td>
  <input v-if="editingIndex === index"
         v-model="dziecko.editedDate"
         class="form-control"
         type="date" />

  <span v-else>
    {{ dziecko.dziecko ? new Date(dziecko.dziecko).toLocaleDateString() : '' }}
  </span>
</td>
                        <td>
                          <input v-if="editingIndex === index" v-model="dziecko.edited_ojcowski_dni" class="form-control"
                            type="number" step="1"/>
                          <span v-else>{{ dziecko.ojcowski_dni ?? 2 }}</span>
                        </td>						
                        <td>
                          <input v-if="editingIndex === index" v-model="dziecko.edited_rodzicielski_dni" class="form-control"
                            type="number" step="1"/>
                          <span v-else>{{ dziecko.rodzicielski_dni ?? 9 }}</span>
                        </td>						
						
                        <td>
                          <button v-if="editingIndex  === index" @click="saveUpdatedDate(index)"
                            class="btn btn-sm btn-success me-2">Zapisz</button>
                          <button v-else @click="startEditing(index)"
                            class="btn btn-sm btn-outline-warning me-2"><i class="bi bi-pencil me-2"></i>Edytuj</button>
                          <button @click="deleteDate(index)" class="btn btn-sm btn-danger"><i
                              class="bi bi-trash me-2"></i>Usuń</button>
                        </td>
                      </tr>
                      <tr v-if="dodajDziecko">
                        <td>
                          <input v-model="newDziecko.data" class="form-control" type="date" />
                        </td>
                        <td>
                          <input v-model="newDziecko.ojcowski_dni" class="form-control" type="number" step="1"/>
                        </td>
                        <td>
                          <input v-model="newDziecko.rodzicielski_dni" class="form-control" type="number" step="1"/>
                        </td>
                        <td>
                          <button @click="saveNewDziecko" class="btn btn-sm btn-success me-1">
                            <i class="bi bi-save me-2"></i>Zapisz
                          </button>
                          <button @click="cancelNewDziecko" class="btn btn-sm btn-danger">
                            <i class="bi bi-x-circle me-2"></i>Anuluj
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="lokalneUmowaOd" class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Terminy pracownika</h5>
                <button @click="openModalAddTermin" class="btn btn-success btn-sm mb-2">
                  <i class="bi bi-plus-circle me-2"></i>Dodaj termin
                </button>

                <div v-if="lokalneTerminyUser.length || dodajTermin" class="table-responsive mb-2">
                  <table class="table table-bordered table-hover">
                    <thead>
                      <tr class="text-center">
                        <th>Rodzaj</th>
                        <th>Wykonano</th>
                        <th>Ważność do</th>
                        <th>Przypomnienie (dni)</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(termin, index) in lokalneTerminyUser" :key="termin.id">
                        <td style="min-width: 150px;">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ termin.termin?.nazwa || '' }}
                            <span v-if="showWarning(termin.data_end, termin.ile_wczesniej)" class="text-warning"
                              title="Termin kończy się w mniej niż 30 dni">⚠️</span>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <span
                              v-if="(termin.stanowisko || '').toLowerCase() !== (lokalnestanowisko || '').toLowerCase()">{{
                              termin.stanowisko || '' }}</span>
                            <span
                              v-if="(termin.stanowisko || '').toLowerCase() !== (lokalnestanowisko || '').toLowerCase() && termin.termin?.check_position == 1"
                              class="text-warning" title="Stanowiska różnią się dla terminu pracownika!">⚠️</span>
                          </div>

                        </td>
                        <td class="text-center">
                          <input v-if="editingIndex === index" v-model="editedDateMake" class="form-control"
                            type="date" />
                          <span v-else class="text-center">{{ termin.data_make ? new
                            Date(termin.data_make).toLocaleDateString() : '' }}</span>
                        </td>
                        <td v-if="isExpired(termin.data_end)" class="bg-danger text-white text-center">
                          <input v-if="editingIndex === index" v-model="editedDateEnd" class="form-control"
                            type="date" />
                          <span v-else class="text-center">{{ termin.data_end ? new
                            Date(termin.data_end).toLocaleDateString() : '' }}</span>
                        </td>
                        <td v-else class="text-center">
                          <input v-if="editingIndex === index" v-model="editedDateEnd" class="form-control"
                            type="date" />
                          <span v-else>{{ termin.data_end ? new Date(termin.data_end).toLocaleDateString() : ''
                            }}</span>
                        </td>
                        <td class="text-center">
                          <input v-if="editingIndex === index" v-model.number="editedIleWczesniej" class="form-control"
                            type="number" min="0" />
                          <span v-else>{{ termin.ile_wczesniej }}</span>
                        </td>
                        <td style="max-width: 100px;" class="text-center">
                          <button v-if="editingIndex === index" @click="UpdatedTermin(index)"
                            class="btn btn-sm btn-success me-2 mb-2">Zapisz</button>
                          <button v-else
                            @click="startEditingTermin(index, termin.data_make, termin.data_end, termin.ile_wczesniej)"
                            class="btn btn-sm btn-outline-warning me-2 mb-2">
                            <i class="bi bi-pencil me-2"></i>Edytuj
                          </button>
                          <button @click="deleteTermin(termin.id)" class="btn btn-sm btn-danger">
                            <i class="bi bi-trash me-2"></i>Usuń
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Pliki (tylko kadry)</h5>
                <div class="row">
                  <ul class="list-group ps-3 me-3 mt-3 mb-3">
                    <li
                      class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                      v-if="localFiles.length > 0">
                      <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                      <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                    </li>

                    <li v-if="isLoadingFiles" class="list-group-item border-0">
                      <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                        Ładowanie...</div>
                    </li>
                    <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                      v-for="file in localFiles" :key="file.id">
                      <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="file.name">{{ file.name }}</div>
                      <div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ file.created_at }}</i></div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                        <div class="d-flex justify-content-end flex-wrap gap-1">
                          <a class="btn btn-sm btn-outline-info" style="width:80px;"
                            :href="route('kadry.download-file', [this.userID, file.name])" download><i
                              class="bi bi-download me-1"></i>Pobierz</a>
                          <button v-if="hasPermission('canEditKadry')" class="btn btn-sm btn-outline-danger"
                            style="width:80px;" @click="deleteFile(file)" type="button"><i
                              class="bi bi-trash me-1"></i>Usuń</button>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item" v-if="localFiles.length <= 0 && !isLoadingFiles">
                      <i>Brak plików</i>
                    </li>
                  </ul>
                </div>

                <form @submit.prevent="submitForm">
                  <div class="row gap-3">
                    <div class="col-12">
                      <label for="attachments">Dodaj pliki:</label>
                      <div v-if="isLoading" class="mt-3">
                        <div class="progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            :style="{ width: uploadProgress + '%' }"></div>
                        </div>
                        <small class="text-muted">{{ uploadProgress }}%</small>
                      </div>
                      <input type="file" id="attachments" multiple @change="handleFileUpload"
                        class="form-control form-control-sm" ref="fileInput" />
                      <div v-if="form.attachments.length">
                        <p class="mt-2">Załączone pliki:</p>
                        <ul class="list-group">
                          <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                            v-for="(file, index) in form.attachments" :key="index">
                            <span class="text-truncate" :title="file.name">{{ file.name }}</span>
                            <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                              @click="removeFile(index)">Usuń</button>
                          </li>
                        </ul>
                      </div>
                      <div v-if="form.attachments.length">
                        <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">{{ isLoading ?
                          'Wysyłanie...' : 'Dodaj pliki' }}</button>
                      </div>

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

       <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Pliki wspólne z BHP</h5>

                <div class="row">
                  <ul class="list-group ps-3 me-3 mt-3 mb-3">
                    <li
                        class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                        v-if="localFilesBHP.length > 0"
                    >
                      <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                      <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                    </li>

                    <!-- Loader -->
                    <li v-if="isLoadingFilesBHP" class="list-group-item border-0">
                      <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                        Ładowanie...
                      </div>
                    </li>

                    <!-- Lista plików -->
                    <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                        v-for="fileBHP in localFilesBHP" :key="fileBHP.id">
                      <!-- Nazwa pliku -->
                      <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="fileBHP.name">
                        {{ fileBHP.name }}
                      </div>

                      <!-- Data utworzenia -->
                      <div class="col-12 col-sm-4 col-md-4 text-muted small">
                        <i>{{ fileBHP.created_at }}</i>
                      </div>

                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                        <div class="d-flex justify-content-end flex-wrap gap-1">
                          <a class="btn btn-sm btn-outline-info" style="width:80px;"
                             :href="route('bhp.download-file', [this.userID, fileBHP.name])"
                             download>
                            <i class="bi bi-download me-1"></i>Pobierz
                          </a>
						  <button class="btn btn-sm btn-outline-danger" style="width:80px;" @click="deleteFileBHP(fileBHP)" type="button">
                            <i class="bi bi-trash me-1"></i>Usuń
                          </button>
                        </div>
                      </div>
                    </li>

                    <!-- Brak plików -->
                    <li class="list-group-item" v-if="localFilesBHP.length <= 0 && !isLoadingFiles">
                      <i>Brak plików</i>
                    </li>
                  </ul>
                </div>
				
				 <form @submit.prevent="submitFormBHP">
                  <div class="row gap-3">
                    <div class="col-12">
                      <label for="attachments">Dodaj pliki:</label>
                      <div v-if="isLoadingBHP" class="mt-3">
                        <div class="progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                               :style="{ width: uploadProgressBHP + '%' }"></div>
                        </div>
                        <small class="text-muted">{{ uploadProgressBHP }}%</small>
                      </div>
                      <input type="file" id="attachments" multiple @change="handleFileUploadBHP"
                             class="form-control form-control-sm" ref="fileInputBHP"/>
                      <div v-if="formBHP.attachments.length">
                        <p class="mt-2">Załączone pliki:</p>
                        <ul class="list-group">
                          <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                              v-for="(fileBHP, index) in formBHP.attachments" :key="index">
                            <span class="text-truncate" :title="fileBHP.name">{{ fileBHP.name }}</span>
                            <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                                    @click="removeFileBHP(index)">Usuń
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div v-if="formBHP.attachments.length">
                        <button type="submit" class="btn btn-primary mt-3" :disabled="isLoadingBHP">
                          {{ isLoadingBHP ? 'Wysyłanie...' : 'Dodaj pliki' }}
                        </button>
                      </div>

                    </div>
                  </div>
                </form>
				
				
              </div>
            </div>
          </div>
        </div>


        <div v-if="isModalOpenAddTermin" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Dodaj nowy termin</h5>
                <button type="button" class="btn-close" @click="closeModalAddTermin"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label" for="termin">Wybierz rodzaj terminu:</label>
                    <select id="termin" v-model="newTermin.termin_id" @change="setDefaultIleWczesniej()"
                      class="form-control">
                      <option disabled value="">-- Wybierz termin --</option>
                      <option v-for="t in lokalneTerminy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="datamake">Data wykonania:</label>
                    <input id="datamake" v-model="newTermin.data_make" class="form-control" type="date" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="waznosc">Ważność:</label>
                    <select id="waznosc" v-model="newTermin.data_end" class="form-control">
                      <option value="">-- wybierz --</option>
                      <option value="bezterminowo">Bezterminowo</option>
                      <option :value="0.5">6 miesięcy</option>
                      <option v-for="year in 10" :key="year" :value="year">
                        {{ year }}
                        {{
                          year === 1
                            ? 'rok'
                            : (year >= 2 && year <= 4 ? 'lata' : 'lat' ) }} </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="ile">Ile dni wcześniej przypomnieć:</label>
                    <input id="ile" v-model.number="newTermin.ile_wczesniej" class="form-control" type="number"
                      min="0" />
                  </div>
                  <div class="col-md-12">
                    <label class="form-label" for="termin_stanowisko">Termin na stanowisko:</label>
                    <input id="termin_stanowisko" v-model="newTermin.stanowisko" class="form-control" type="text" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeModalAddTermin">Anuluj</button>
                <button class="btn btn-primary" @click="saveNewTermin">Dodaj termin</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isModalOpenStaze" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Historia zatrudnienia</h5>

                <button type="button" class="btn-close" @click="closeModalStaze"></button>


              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <button @click="addNewStaz" class="btn btn-success btn-sm mb-2">
                      <i class="bi bi-plus-circle me-2"></i>Dodaj okres zatrudnienia
                    </button>

                    <div v-if="addingNew" class="row">
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staznazwa">Nazwa (miejsce zatrudnienia):</label>
                        <input id="staznazwa" v-model="newStaz.nazwa" type="text" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staz_od">Zatrudnienie od:</label>
                        <input id="staz_od" v-model="newStaz.staz_od" type="date" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staz_do">Zatrudnienie do:</label>
                        <input id="staz_do" v-model="newStaz.staz_do" type="date" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="stazstanowisko">Stanowisko:</label>
                        <input id="stazstanowisko" v-model="newStaz.stanowisko" type="text" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="stazEtat">Wybierz rodzaj etatu:</label>
                        <select id="stazEtat" v-model="newStaz.etat" class="form-control">
                          <option disabled value="">-- Wybierz Etat --</option>
                          <option v-for="et in typy_etaty" :key="et.id" :value="et.id">{{ et.nazwa }}</option>
                        </select>
                      </div>

                      <div class="modal-footer">

                        <button @click="saveNewStaz" class="btn btn-sm btn-outline-success"><i
                            class="bi bi-save me-2"></i>Zapisz</button>
                        <button @click="cancelNewStaz" class="btn btn-sm btn-outline-primary"><i
                            class="bi bi-x-circle me-2"></i>Anuluj</button>
                      </div>
                    </div>

                    <div v-if="editingId === editedStaz.id" class="row">
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staznazwa">Nazwa (miejsce zatrudnienia):</label>
                        <input id="staznazwa" v-model="editedStaz.nazwa" type="text" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staz_od">Zatrudnienie od:</label>
                        <input id="staz_od" v-model="editedStaz.staz_od" type="date" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="staz_do">Zatrudnienie do:</label>
                        <input id="staz_do" v-model="editedStaz.staz_do" type="date" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="stazstanowisko">Stanowisko:</label>
                        <input id="stazstanowisko" v-model="editedStaz.stanowisko" type="text" class="form-control"
                          style="border-radius: 0;" />
                      </div>
                      <div class="col-md-12 col-lg-12 mb-3">
                        <label class="form-label" for="stazEtat">Wybierz rodzaj etatu:</label>
                        <select id="stazEtat" v-model="editedStaz.etat" class="form-control">
                          <option disabled value="">-- Wybierz Etat --</option>
                          <option v-for="ut in typy_etaty" :key="ut.id" :value="ut.id">{{ ut.nazwa }}</option>
                        </select>
                      </div>
                      <div class="modal-footer">
                        <button @click="updateStaz(editedStaz)" class="btn btn-sm btn-outline-success"><i
                            class="bi bi-save me-2"></i>Zapisz</button>
                        <button @click="cancelEditStaz" class="btn btn-sm btn-outline-primary"><i
                            class="bi bi-x-circle me-2"></i>Anuluj</button>
                      </div>
                    </div>

                    <div class="custom-table ">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Nazwa</th>
                              <th>Od</th>
                              <th>Do</th>
                              <th>Stanowisko</th>
                              <th>Etat</th>
                              <th>Akcje</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(staz, index) in userStaz" :key="index">
                              <td>{{ index + 1 }}</td>
                              <td>{{ staz.nazwa }}</td>
                              <td style="width: 95px;">{{ staz.staz_od }}</td>
                              <td style="width: 95px;">{{ staz.staz_do }}</td>
                              <td style="width: 95px;">{{ staz.stanowisko }}</td>
                              <td style="width: 95px;">{{ getNazwaEtatu(staz.etat) }}</td>

                              <td style="width: 80px;" class="text-center">
                                <!-- Zapisz -->
                                <button v-if="editingId === staz.id" @click="updateStaz(staz)"
                                  class="btn btn-sm btn-success me-2 mb-2">
                                  Zapisz
                                </button>

                                <!-- Edytuj i Usuń -->
                                <template v-else-if="lokalneStazID !== staz.id">
                                  <button @click="editStaz(staz)" class="btn btn-sm btn-outline-info me-2 mb-2">
                                    <i class="bi bi-pencil me-2"></i>Edytuj
                                  </button>
                                  <br>
                                  <button @click="deleteStaz(staz.id)" class="btn btn-sm btn-danger">
                                    <i class="bi bi-trash me-2"></i>Usuń
                                  </button>
                                </template>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeModalStaze">Zamknij</button>

              </div>
            </div>
          </div>
        </div>




      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import Multiselect from '@suadelabs/vue3-multiselect';
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import { router } from "@inertiajs/vue3";

const { hasPermission } = usePermission();

export default {
  props: {
    initialDepartments: {
      type: Array,
      default: () => []
    },

    userData: Object,
    userDane: Object,
    typyUrlopow: Array,
    opcjeUrlopow: Object,
    tenRok: Number,
    poprzedniRok: Number,
    wnioskiUrlopowe: Array,
    dzieci: Array,
    dzieciall: Array,
    userImie: String,
    userNazwisko: String,
    departament: String,
    departament_en: String,
    userID: Number,
    departament_id: Number,
    godziny_id: Array,
    is_active: Boolean,
    wyksztalcenie: Number,
    inwalida: Number,
    weteran: Number,
	nauka: Number,
    departament_name: String,
    departamenty: Array,
    oddzialy: Array,
    typy_umow: Array,
    typy_etaty: Array,
    smart_uprawnienia: Array,
    smart_dzialy: Array,
    smartData: Array,
    Smart_nr_karty: String,
    userPhoneFir: String,
    userEmailFir: String,
    newTermin: {
      termin_id: '',
      data_make: '',
      data_end: '',
      ile_wczesniej: null,
    },
    terminy: {
      type: Array,
      default: () => []
    },
    userStaz: {
      type: Array,
      default: () => []
    },
    userEtat: null,


    terminyUser: {
      type: Array,
      default: () => []
    },
    pliki: {
      type: Array,
      required: true,
      default: () => []
    },
	plikiBHP: {
      type: Array,
      required: true,
      default: () => []
    }
  },


  components: { AppLayout, 'ejs-daterangepicker': DateRangePickerComponent, hasPermission, Multiselect },
  data() {
    const now = new Date();

    const today = new Date();
    return {
      initAttachments: [],
	  initAttachmentsBHP: [],
      form: {
        name: null,
        attachments: [],
        errors: {}
      },
	        formBHP: {
        name: null,
        attachments: [],
        errors: {}
      },
	  editingIndex: null,
      addingNew: false,
      isLoadingFiles: true,
      isLoading: false,
      isProcessing: false,
      uploadProgress: 0,
      uploadError: null,
      uploadSuccess: false,
      isLoadingFilesBHP: true,
      isLoadingBHP: false,
      isProcessingBHP: false,
      uploadProgressBHP: 0,
      uploadErrorBHP: null,
      uploadSuccessBHP: false,	  
      localFiles: [...this.pliki],
	  localFilesBHP: [...this.plikiBHP],
      lokalneTerminy: [...this.terminy],
      lokalneUserStaz: this.userEtat ?? null,
      lokalneTerminyUser: [...this.terminyUser],
      lokalnedzial: [],
      lokalnePlec: this.userDane.plec ?? 0,
      lokalneImie: this.userImie ?? '',
      lokalneNazwisko: this.userNazwisko ?? '',
      lokalneWyksztalcenie: this.userDane.wyksztalcenie ?? null,
	  lokalneDataZUS: this.userDane.data_zus ?? null,
	  lokalneDataUrodzenia: this.userData.data_urodzenia ?? null,
	  lokalneMiejsceUrodzenia: this.userData.miejsce_urodzenia ?? null,
      lokalneInwalida: this.userDane.inwalida ?? null,
      lokalneWeteran: this.userDane.weteran ?? null,
      lokalneNauka: this.userDane.nauka ?? 1,
	  
      lokalneGodziny: this.userDane.godziny ?? '',
      lokalnestanowisko: this.departament ?? '',
      lokalnestanowiskoEN: this.departament_en ?? '',
	  
      lokalneNrKarty: this.userDane.nr_karty ?? '',
      lokalneOddzial: this.userDane.oddzial,
      lokalneUmowaDo: this.userDane.umowa_do ?? '',
      lokalneUmowaOd: this.userDane.umowa_od ?? '',
      lokalneTenRok: this.tenRok ?? 0,
      lokalnepoprzedniRok: this.poprzedniRok ?? 0,
      lokalnyIsActive: this.is_active ?? false,
      lokalneOjcowski: this.userDane.ojcowski ?? 0,
      lokalneRodzicielski: this.userDane.rodzicielski ?? 0,
      lokalneKod: this.userData.kod_pocztowy ?? '',
      lokalneMiasto: this.userData.miasto ?? '',
      lokalneUlica: this.userData.ulica ?? '',
      lokalneNr: this.userData.nr_domu ?? '',
      lokalneTelPr: this.userData.nr_telefonu ?? '',
      lokalneTelFir: this.userPhoneFir ?? '',
      lokalneEmPr: this.userData.email ?? '',
      lokalneEmFir: this.userEmailFir ?? '',
      lokalneUmowaTyp: this.userDane.umowa ?? null,
      lokalneEtatTyp: this.userDane.etat ?? 1,
      lokalneStazID: this.userDane.staz_id ?? null,
      lokalneSmartNrKarty: this.Smart_nr_karty ?? '',
      lokalneSmartPrivilageID: this.smartData?.PrivilageID ?? 0,

      listaWyksztalcenia: [0, 1, 2, 3, 4, 5],
      months: [
        'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
        'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
      ],
      availableYears: this.generateYearRange(now.getFullYear() - 10, now.getFullYear() + 1),


      currentMonth: today.getMonth(),
      currentYear: today.getFullYear(),
      daysOfWeek: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb', 'Nd'],
      wnioskiUrlopowe: [],
      dateRange: [today, today],
      workingDaysCount: null,
      wolnedni: null,
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
      editingDate: null,     // która data jest edytowana
      editedDate: '',
      editedDateMake: '',
      editedDateEnd: '',
      wykorzystanychDniWolnych: 0,

      formError: false,
      dodajDziecko: false,
      newDziecko: {
        data: ''
      },
      isModalOpenAddTermin: false,
      isModalOpenStaze: false,
      dodajTermin: false,
      newTermin: {
        termin_id: '',
        data: '',
        ile_wczesniej: null,
        stanowisko: this.departament ?? '',
      },
      ileWczesniejOptions: [
        { value: null, label: 'Bezterminowo' },
        { value: 1, label: '1 rok' },
        { value: 2, label: '2 lata' },
        { value: 3, label: '3 lata' },
        { value: 4, label: '4 lata' },
        { value: 5, label: '5 lat' },
        { value: 6, label: '6 lat' },
        { value: 7, label: '7 lat' },
        { value: 8, label: '8 lat' },
        { value: 9, label: '9 lat' },
        { value: 10, label: '10 lat' },
      ],
      editingIndex: null,
      editingId: null,
      editedStaz: {},
      editedIleWczesniej: null,
      hasPermission
    };
  },
  async mounted() {
    this.fetchWnioski();
    this.lokalneOjcowski = this.userDane.ojcowski;
    this.lokalneRodzicielski = this.userDane.rodzicielski;
    this.fetchTerminy();
    this.initAttachments = await this.getAttachments(); // <- ważne await
    this.matchFiles();
	this.initAttachmentsBHP = await this.getAttachmentsBHP();
	    this.matchFilesBHP();
    this.isLoadingFiles = false;
    if (this.departamenty.length && this.initialDepartments.length) {
      this.lokalnedzial = this.departamenty.filter(d =>
        this.initialDepartments.includes(d.id)
      );
    }

  },


  computed: {

    showUmowaWarning() {
      if (!this.lokalneUmowaDo) return false;

      const today = new Date();
      const umowaDate = new Date(this.lokalneUmowaDo);
      const diffInTime = umowaDate - today;
      const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

      return diffInDays >= 0 && diffInDays < 30;
    },


    currentMonthName() {
      return new Date(this.currentYear, this.currentMonth).toLocaleString('pl-PL', { month: 'long' });
    },

    razemDniWolnych() {
      return (this.lokalneTenRok || 0) + (this.lokalnepoprzedniRok || 0);
    },

    zostaloDniWolnych() {
      return this.razemDniWolnych - this.wykorzystanychDniWolnych;
    },
  },
  watch: {
    selectedYear(newVal) {
      this.currentYear = newVal;
    },
    departamenty: {
      immediate: true,
      handler(newVal) {
        if (newVal.length && this.initialDepartments.length) {
          this.lokalnedzial = newVal.filter(d =>
            this.initialDepartments.includes(d.id)
          );
          //console.log('lokalnedzial po filter:', this.lokalnedzial);
        }
      }
    },
    initialDepartments: {
      immediate: true,
      handler(newVal) {
        if (newVal.length && this.departamenty.length) {
          this.lokalnedzial = this.departamenty.filter(d =>
            newVal.includes(d.id)
          );
          //console.log('lokalnedzial po filter:', this.lokalnedzial);
        }
      }
    }

  },
  methods: {
    async deleteFile(file) {
      let self = this;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(route('kadry.file.delete', {
              user_id: self.userID,
              attachment: file.id
            }));

            if (response.data.icon === 'success') {
              self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
              await self.refreshAttachments(); // odśwież listę plików
            } else {
              self.showToast('error', response.data.title, response.data.message);
            }

          } catch (error) {
            console.error("Błąd usuwania pliku:", error);
            self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
          }
        }
      });
    },

    async deleteFileBHP(fileBHP) {
      let self = this;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(route('bhp.file.delete', {
              user_id: self.userID,
              attachment: fileBHP.id
            }));

            if (response.data.icon === 'success') {
              self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
              await self.refreshAttachmentsBHP(); // odśwież listę plików
            } else {
              self.showToast('error', response.data.title, response.data.message);
            }

          } catch (error) {
            console.error("Błąd usuwania pliku:", error);
            self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
          }
        }
      });
    },

    async getAttachments() {
      const user_id = this.userID;
      try {
        const response = await axios.post(route('kadry.get.userfiles', { user_id: user_id }));
        return response.data.attachments ?? [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    async getAttachmentsBHP() {
      const user_id = this.userID;
       try {
        const response = await axios.post(route('bhp.get.userfiles', {user_id: user_id}));
        return response.data.attachments ?? [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },
	
    handleFileUpload(event) {
      this.uploadError = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFiles = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadError = `Plik "${file.name}" jest pusty.`;
        } else {
          validFiles.push(file);
        }
      }

      if (validFiles.length > 0) {
        this.form.attachments.push(...validFiles);
      }

      this.$refs.fileInput.value = "";
    },

    handleFileUploadBHP(event) {
      this.uploadErrorBHP = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFilesBHP = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadErrorBHP = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadErrorBHP = `Plik "${file.name}" jest pusty.`;
        } else {
          validFilesBHP.push(file);
        }
      }

      if (validFilesBHP.length > 0) {
        this.formBHP.attachments.push(...validFilesBHP);
      }

      this.$refs.fileInputBHP.value = "";
    },
	
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
    removeFileBHP(index) {
      this.formBHP.attachments.splice(index, 1);
    },

    matchFiles() {
      try {
        if (this.initAttachments.length > 0) {
          this.localFiles = [...this.initAttachments];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },
    matchFilesBHP() {
      try {
        if (this.initAttachmentsBHP.length > 0) {
          this.localFilesBHP = [...this.initAttachmentsBHP];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFilesBHP = false;
      }
    },
    async refreshAttachments() {
      this.isLoadingFiles = true;
      try {
        const attachments = await this.getAttachments();
        this.localFiles = attachments;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async refreshAttachmentsBHP() {
      this.isLoadingFilesBHP = true;
      try {
        const attachments = await this.getAttachmentsBHP();
        this.localFilesBHP = attachments;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFilesBHP = false;
      }
    },

    async submitForm() {
      this.form.errors = {};
      this.uploadError = null;
      this.uploadProgress = 0;
      this.isProcessing = true;

      if (this.form.attachments.length === 0) {
        this.uploadError = "Nie wybrano plików do wysłania.";
        this.isProcessing = false;
        return;
      }

      this.isLoading = true;
      let formData = new FormData();
      this.form.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      const user_id = this.userID;

      try {
        const response = await axios.post(route('kadry.add.file', { user_id }), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });

        this.form.attachments = [];
        await this.refreshAttachments();
        this.$refs.fileInput.value = "";
        this.uploadProgress = 100;

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
      } finally {
        this.isProcessing = false;
        this.isLoading = false;

        setTimeout(() => this.uploadProgress = 0, 3000);
      }
    },

    async submitFormBHP() {
      this.formBHP.errors = {};
      this.uploadErrorBHP = null;
      this.uploadProgressBHP = 0;
      this.isProcessingBHP = true;

      if (this.formBHP.attachments.length === 0) {
        this.uploadErrorBHP = "Nie wybrano plików do wysłania.";
        this.isProcessingBHP = false;
        return;
      }

      this.isLoadingBHP = true;
      let formData = new FormData();
      this.formBHP.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      const user_id = this.userID;

      try {
        const response = await axios.post(route('bhp.add.file', {user_id}), formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgressBHP: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgressBHP = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });

        // po sukcesie
        this.formBHP.attachments = [];
        await this.refreshAttachmentsBHP();
        this.$refs.fileInputBHP.value = "";
        this.uploadProgressBHP = 100;

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.uploadErrorBHP = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
      } finally {
        this.isProcessingBHP = false;
        this.isLoadingBHP = false;

        setTimeout(() => this.uploadProgressBHP = 0, 3000);
      }
    },
	
    getNazwaEtatu(id) {
      const etat = this.typy_etaty.find(t => t.id === id);
      return etat ? etat.nazwa : '—';
    },

    addNewStaz() {
      this.addingNew = true;
      this.newStaz = this.getEmptyFormStaz();
    },

    cancelNewStaz() {
      this.addingNew = false;
      this.newStaz = this.getEmptyFormStaz();
    },

    cancelEditStaz() {
      this.editingId = null;
    },

    editStaz(staz) {
      this.editingId = staz.id;
      this.editedStaz = { ...staz };
    },

    getEmptyFormStaz() {
      return {
        id: null,
        nazwa: '',
        staz_od: '',
        staz_do: '',
        stanowisko: '',
        etat: ''
      };
    },

    updateStaz(staz) {
      this.$inertia.put(route('kadry.staz.update', staz.id), staz, {
        onSuccess: () => {
          this.editingId = null;
          this.fetchWnioski();
        }
      });
    },

    saveNewStaz() {
      const user_id = this.userID;
      this.$inertia.post(route('kadry.staz.dodaj', user_id), this.newStaz, {
        onSuccess: () => {
          this.addingNew = false;
          this.newStaz = this.getEmptyFormStaz();
          this.fetchWnioski();
        }
      });
    },

    deleteStaz(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie historii zatrudnienia',
        html: 'Czy na pewno chcesz usunąć wybraną pozycję?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.staz.usun', id));
          this.fetchWnioski();
        }
      })
    },


    async openModalAddTermin() {
      this.isModalOpenAddTermin = true;
    },
    async openModalStaze() {
      this.isModalOpenStaze = true;
    },
    isExpired(data_end) {
      // console.log('data_end:', data_end);
      if (!data_end) return false;

      const today = new Date();
      const DateEnd = (data_end instanceof Date) ? data_end : new Date(data_end);
      // console.log('DateEnd:', DateEnd);
      if (isNaN(DateEnd)) return false;

      const roznica = (DateEnd - today) / (1000 * 60 * 60 * 24);
      //console.log('roznica', roznica);
      return roznica < 0;
    },

    showWarning(data_do, days) {
      if (!data_do) return false;
      if (!days) return false;

      const today = new Date();
      const DateDo = (data_do instanceof Date) ? data_do : new Date(data_do);

      if (isNaN(DateDo)) {
        return false;
      }

      const kiedy = DateDo - today;
      const zostalo_dni = kiedy / (1000 * 60 * 60 * 24);

      return zostalo_dni < days;
    },

    closeModalAddTermin() {
      this.isModalOpenAddTermin = false;
      this.getEmptyFormTerminy();
    },

    closeModalStaze() {
      this.isModalOpenStaze = false;
      this.addingNew = false;
      this.newStaz = this.getEmptyFormStaz();
      this.editingId = null;

    },

    async zapiszWszystko() {
      try {
        const daneDoZapisu = {
          imie: this.lokalneImie,
          nazwisko: this.lokalneNazwisko,
          position: this.lokalnestanowisko,
          position_en: this.lokalnestanowiskoEN,
          department_id: Array.isArray(this.lokalnedzial) ? this.lokalnedzial.map(d => d.id ?? d) : [],
          godziny: this.lokalneGodziny,
          umowa_od: this.lokalneUmowaOd,
          umowa_do: this.lokalneUmowaDo,
          umowa: this.lokalneUmowaTyp,
          plec: this.lokalnePlec,
          etat: this.lokalneUserStaz,
          wyksztalcenie: this.lokalneWyksztalcenie,
		  data_zus: this.lokalneDataZUS,
          inwalida: this.lokalneInwalida,
          weteran: this.lokalneWeteran,
		  nauka: this.lokalneNauka,
          nr_karty: this.lokalneNrKarty,
          ten_rok: this.lokalneTenRok,
          oddzial: this.lokalneOddzial,
          poprzedni_rok: this.lokalnepoprzedniRok,
          is_active: this.lokalnyIsActive ? 1 : 0,

          kod_pocztowy: this.lokalneKod,
          miasto: this.lokalneMiasto,
          ulica: this.lokalneUlica,
          nr_domu: this.lokalneNr,
          nr_telefonu: this.lokalneTelPr,
          email: this.lokalneEmPr,
          phone: this.lokalneTelFir,
          emailfir: this.lokalneEmFir,
		  data_urodzenia: this.lokalneDataUrodzenia,
		  miejsce_urodzenia: this.lokalneMiejsceUrodzenia,
        };
        await axios.put(route('kadry.urlopy.update.data.user', this.userDane.user_id), daneDoZapisu);
        this.fetchWnioski();
        const index = this.userStaz.findIndex(s => s.nazwa === 'ASKLA');
        if (index !== -1) {
          // Edytuj istniejący
          this.userStaz[index].staz_od = this.lokalneUmowaOd;
          this.userStaz[index].staz_do = this.lokalneUmowaDo;
          this.userStaz[index].stanowisko = this.lokalnestanowisko;
          this.userStaz[index].etat = this.lokalneUserStaz;
        } else {
          // Dodaj nowy do tablicy
          this.userStaz.push({
            id: Date.now(), // tymczasowe ID, można podmienić na backendowe po odświeżeniu
            nazwa: 'ASKLA',
            staz_od: this.lokalneUmowaOd,
            staz_do: this.lokalneUmowaDo,
            stanowisko: this.lokalnestanowisko,
            etat: this.lokalneUserStaz,
          });
        }
        this.$inertia.reload({ only: ['userDane', 'userData', 'userStaz', 'userEtat'] });

        this.showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
      }
    },

    addDziecko() {
      this.dodajDziecko = true;
      this.newDziecko = this.getEmptyForm();
    },

    cancelNewDziecko() {
      this.dodajDziecko = false;
      this.newDziecko = this.getEmptyForm();
    },

getEmptyForm() {
  return {
    data: '',
    ojcowski_dni: 2,
    rodzicielski_dni: 9
  };
},

    async saveNewDziecko() {
      if (!this.newDziecko.data) {
        this.showToast('error', 'Błąd', 'Podaj datę urodzenia dziecka.');
        return;
      }

      try {
        const user_id = this.userData.user_id;
await axios.post(route('kadry.add.dziecko', user_id), {
  dziecko: this.newDziecko.data,
  ojcowski_dni: this.newDziecko.ojcowski_dni,
  rodzicielski_dni: this.newDziecko.rodzicielski_dni
});

this.dzieciall.push({
  dziecko: this.newDziecko.data,
  ojcowski_dni: this.newDziecko.ojcowski_dni,
  rodzicielski_dni: this.newDziecko.rodzicielski_dni
});
        this.dodajDziecko = false;
        this.newDziecko = this.getEmptyForm();


        this.showToast('success', 'Dodano', 'Dziecko zostało dodane.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się dodać dziecka.');
      }
    },
    async saveNewTermin() {
      if (!this.newTermin.data_make) {
        this.showToast('error', 'Błąd', 'Podaj datę dla nowego terminu.');
        return;
      }
      if (!this.newTermin.termin_id) {
        this.showToast('error', 'Błąd', 'Wybierz rodzaj nowego terminu.');
        return;
      }
      const user_id = this.userData.user_id;
      let dataEndValue = this.newTermin.data_end;
      if (dataEndValue === 'bezterminowo' || dataEndValue === '') {
        dataEndValue = null;
      }
      //console.log('this.lokalnestanowisko',this.lokalnestanowisko);
      try {
        const response = await axios.post(route('kadry.add.termin', user_id), {
          data_make: this.newTermin.data_make,
          data_end: dataEndValue,
          termin_id: this.newTermin.termin_id,
          ile_wczesniej: this.newTermin.ile_wczesniej,
          stanowisko: this.newTermin.stanowisko,
        });

        this.isModalOpenAddTermin = false;
        this.newTermin = this.getEmptyFormTerminy();

        this.fetchTerminy();
        this.showToast('success', 'Dodano', 'Termin został dodany.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się dodać terminu.');
      }
    },




startEditing(index) {
  this.editingIndex = index;

 const d = this.dzieciall[index];

  // 🔥 KLUCZOWE – format YYYY-MM-DD
  this.dzieciall[index].editedDate = d.dziecko
    ? new Date(d.dziecko).toISOString().split('T')[0]
    : '';
  this.dzieciall[index].edited_ojcowski_dni = this.dzieciall[index].ojcowski_dni ?? 2 ;
  this.dzieciall[index].edited_rodzicielski_dni = this.dzieciall[index].rodzicielski_dni ?? 9;
},

    startEditingTermin(index, dataMake, dataEnd, ileWczesniej) {
      this.editingIndex = index;
      this.editedDateMake = dataMake || '';
      this.editedDateEnd = dataEnd || '';
      this.editedIleWczesniej = ileWczesniej ?? '';
    },

    setDefaultIleWczesniej() {
      if (this.newTermin.ile_wczesniej === null || this.newTermin.ile_wczesniej === undefined || this.newTermin.ile_wczesniej === '') {
        const selected = this.lokalneTerminy.find(t => t.id === this.newTermin.termin_id);
        this.newTermin.ile_wczesniej = selected ? selected.ile_wczesniej : 0;
      }
    },

async saveUpdatedDate(index) {
  const dziecko = this.dzieciall[index];

  const oldFormatted = dziecko.dziecko;

  const newFormatted = typeof dziecko.editedDate === 'string'
    ? dziecko.editedDate
    : new Date(dziecko.editedDate).toISOString().split('T')[0];

  Toast.fire({
    toast: false,
    icon: 'warning',
    title: 'Edycja danych dziecka',
    html: 'Czy na pewno chcesz zmienić dane dziecka?',
    showDenyButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Tak',
    denyButtonText: 'Nie',
    position: 'center',
    timer: false,
  }).then((result) => {
    if (result.isConfirmed) {
      const user_id = this.userData.user_id;

      axios.put(route('kadry.update.dziecko', user_id), {
        old: oldFormatted,
        new: newFormatted,
        ojcowski_dni: dziecko.edited_ojcowski_dni,
        rodzicielski_dni: dziecko.edited_rodzicielski_dni
      })
      .then(() => {

        Toast.fire({
          icon: 'success',
          title: 'Dane dziecka zostały zmienione'
        });

        // 🔥 aktualizacja lokalna
this.dzieciall[index] = {
  dziecko: newFormatted,
  ojcowski_dni: dziecko.edited_ojcowski_dni || 2,
  rodzicielski_dni: dziecko.edited_rodzicielski_dni || 9
};

        this.editingIndex = null;
      })
      .catch(error => {
        console.error(error);
        Toast.fire({
          icon: 'error',
          title: 'Błąd podczas edycji dziecka',
          text: error.response?.data?.message || 'Wystąpił błąd'
        });
      });
    }
  });
},

async deleteDate(index) {
  const dziecko = this.dzieciall[index];

  Toast.fire({
    toast: false,
    icon: 'warning',
    title: 'Usunięcie dziecka',
    html: 'Czy na pewno chcesz usunąć to dziecko?',
    showDenyButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Tak',
    denyButtonText: 'Nie',
    position: 'center',
    timer: false,
  }).then((result) => {
    if (result.isConfirmed) {
      const user_id = this.userData.user_id;

      axios.delete(route('kadry.usun.dziecko', user_id), {
        data: { dziecko: dziecko.data }
      })
      .then(() => {

        Toast.fire({
          icon: 'success',
          title: 'Dziecko usunięte'
        });

        this.dzieciall.splice(index, 1);
      })
      .catch(error => {
        console.error(error);
        Toast.fire({
          icon: 'error',
          title: 'Nie udało się usunąć dziecka',
          text: error.response?.data?.message || 'Błąd'
        });
      });
    }
  });
},
    async UpdatedTermin(index) {
      const termin = this.lokalneTerminyUser[index];
      if (!termin) return;

      const newFormattedMake = typeof this.editedDateMake === 'string'
        ? this.editedDateMake
        : new Date(this.editedDateMake).toISOString().split('T')[0];

      const newFormattedEnd = typeof this.editedDateEnd === 'string'
        ? this.editedDateEnd
        : new Date(this.editedDateEnd).toISOString().split('T')[0]

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Edycja terminu',
        html: 'Czy na pewno chcesz zmienić dane terminu?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        position: 'center',
        timer: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const user_id = this.userData.user_id;
          axios.put(route('kadry.update.termin', user_id), {
            newMake: newFormattedMake,
            newEnd: newFormattedEnd,
            termin_id: termin.id,
            ile_wczesniej: this.editedIleWczesniej,
          })
            .then(() => {
              Toast.fire({ icon: 'success', title: 'Dane terminu zostały zmienione' });

              this.$set(this.lokalneTerminyUser[index], 'data_make', newFormattedMake);
              this.$set(this.lokalneTerminyUser[index], 'data_end', newFormattedEnd);
              this.$set(this.lokalneTerminyUser[index], 'ile_wczesniej', this.editedIleWczesniej);

              this.editingIndex = null;
              this.editedDateMake = '';
              this.editedDateEnd = '';
              this.editedIleWczesniej = null;
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się zmienić danych terminu',
                text: error.response?.data?.message || 'Wystąpił błąd podczas zmiany danych',
              });
            });
        }
      });
    },

    async deleteTermin(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usunięcie terminu',
        html: 'Czy na pewno chcesz usunąć ten termin?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        position: 'center',
        timer: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const user_id = this.userData.user_id;
          axios.delete(route('kadry.usun.termin', user_id), {
            data: { termin_id: id } // DELETE z payload
          })
            .then(() => {
              Toast.fire({ icon: 'success', title: 'Termin został usunięty' });

              const index = this.lokalneTerminyUser.findIndex(t => t.id === id);
              if (index !== -1) {
                this.lokalneTerminyUser.splice(index, 1);
              }
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się usunąć terminu',
                text: error.response?.data?.message || 'Wystąpił błąd podczas usuwania terminu',
              });
            });
        }
      });
    },

    async save(coUpdate, wartosc) {
      //console.log('Zapisuję:', coUpdate);
      //console.log('Wartość:', wartosc);
      //console.log('dla roku:', this.selectedYear);

      try {
        const user_id = this.userData.user_id;
        await axios.put(route('kadry.urlopy.update.user', user_id), {
          what: coUpdate,
          val: wartosc,
          year: this.selectedYear,
        });
        this.showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
      }
    },

    formatDateToYMD(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    isHoliday(dateInput) {
      if (!dateInput) return false;

      // Zamieniamy na string 'YYYY-MM-DD' jeśli to Date
      const dateStr = typeof dateInput === 'string'
        ? dateInput
        : this.formatDate(dateInput);

      const year = parseInt(dateStr.substring(0, 4));
      const holidays = this.getPolishHolidays(year);
      return holidays.includes(dateStr);
    },

    getPolishHolidays(year) {
      const fixedHolidays = [
        `${year}-01-01`,
        `${year}-01-06`,
        `${year}-05-01`,
        `${year}-05-03`,
        `${year}-08-15`,
        `${year}-11-01`,
        `${year}-11-11`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
      ];

      const easter = this.getEasterDate(year);
      const holidays = [...fixedHolidays];
      holidays.push(this.formatDate(easter));
      holidays.push(this.formatDate(new Date(easter.getTime() + 86400000))); // Poniedziałek wielkanocny
      holidays.push(this.formatDate(new Date(easter.getTime() + 60 * 86400000))); // Boże Ciało

      return holidays;
    },

    // Wielkanoc
    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year / 100);
      const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
      const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
      const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
      const L = I - J;
      const month = 3 + f((L + 40) / 44);
      const day = L + 28 - 31 * f(month / 4);
      return new Date(year, month - 1, day);
    },

    // Formatowanie daty do YYYY-MM-DD
    formatDate(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${d}`;
    },


    generateYearRange(start, end) {
      const years = [];
      for (let y = start; y <= end; y++) {
        years.push(y);
      }
      return years;
    },

    toLocalDate(dateStr) {
      const [y, m, d] = this.formatDate(dateStr).split('-').map(Number);
      return new Date(y, m - 1, d, 0, 0, 0);
    },


    countWorkingDaysInYear(startDate, endDate, year) {
      let count = 0;
      const holidaysCache = {};
      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        const y = current.getFullYear();
        if (y !== year) {
          current.setDate(current.getDate() + 1);
          continue;
        }

        const day = current.getDay();
        if (!holidaysCache[y]) {
          holidaysCache[y] = this.getPolishHolidays(y);
        }
        const dateStr = this.formatDate(current);
        const isWeekend = day === 0 || day === 6;
        const isHoliday = holidaysCache[y].includes(dateStr);
        if (!isWeekend && !isHoliday) count++;

        current.setDate(current.getDate() + 1);
      }

      return count;
    },

    obliczWykorzystaneDniWolne() {
      if (!this.wnioskiUrlopowe || !Array.isArray(this.wnioskiUrlopowe)) {
        this.wykorzystanychDniWolnych = 0;
        return;
      }
      const year = this.selectedYear;
      let suma = 0;

      this.wnioskiUrlopowe.forEach(wniosek => {
        if (wniosek.status !== 1) return; // tylko zatwierdzone
        const typ = this.typyUrlopow.find(t => t.id === wniosek.typ_id);
        if (!typ || typ.wypoczynkowy !== 1) return;
        const start = new Date(wniosek.start);
        const end = new Date(wniosek.end);

        const yearStart = new Date(year, 0, 1);  // 01.01 wybranego roku
        const yearEnd = new Date(year, 11, 31); // 31.12 wybranego roku

        const realStart = start < yearStart ? yearStart : start;
        const realEnd = end > yearEnd ? yearEnd : end;

        suma += this.countWorkingDays(realStart, realEnd);
      });

      this.wykorzystanychDniWolnych = suma;
    },
    fetchWnioski() {
      const rok = this.selectedYear;
      const user_id = this.userData.user_id;
      axios.get(route('urlopy.get.user'), {
        params: { rok, user_id }
      })
        .then(response => {
          this.wnioskiUrlopowe = response.data.wnioski; // <- poprawnie przypisujemy tablicę
          this.lokalneTenRok = response.data.posiadaneUrlopy.tenRok;
          this.lokalnepoprzedniRok = response.data.posiadaneUrlopy.poprzedniRok;
          this.obliczWykorzystaneDniWolne();
        })
        .catch(error => {
          console.error("Błąd podczas pobierania wniosków urlopowych:", error);
        });
    },

    fetchTerminy() {
      const user_id = this.userData.user_id;
      axios.get(route('kadry.get.user.terminy'), { params: { user_id } })
        .then(response => {
          this.lokalneTerminy = response.data.terminy;
          this.lokalneTerminyUser = response.data.terminyUser;
        })
        .catch(error => {
          console.error("Błąd podczas pobierania terminów pracownika:", error);
        });
    },
    getEmptyFormTerminy() {
      return {
        termin_id: '',
        opis: '',
        data_make: '',
        data_end: ''
      };
    },
    addTermin() {
      this.dodajTermin = true;
      this.newTermin = this.getEmptyFormTerminy();
    },
    cancelNewTermin() {
      this.dodajTermin = false;
      this.newTermin = this.getEmptyFormTerminy();
    },

    NaukaIdNaTekst(nauka) {
      switch (nauka) {
        case 0: return 'Brak';
        case 1: return 'Zasadnicze lub zawodowe';
        case 2: return 'Średnie zawodowe';
        case 3: return 'Średnie ogólnokształcące';
        case 4: return 'Policealne';
        case 5: return 'Wyższe';
        default: return 'Brak';
      }
    },

    formatDateToYMD(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    countWorkingDaysInYear(startDate, endDate, year) {
      let count = 0;
      const holidaysCache = {};
      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        const y = current.getFullYear();
        if (y !== year) {
          current.setDate(current.getDate() + 1);
          continue;
        }

        const day = current.getDay();
        if (!holidaysCache[y]) {
          holidaysCache[y] = this.getPolishHolidays(y);
        }
        const dateStr = this.formatDate(current);
        const isWeekend = day === 0 || day === 6;
        const isHoliday = holidaysCache[y].includes(dateStr);
        if (!isWeekend && !isHoliday) count++;

        current.setDate(current.getDate() + 1);
      }

      return count;
    },



    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>
<style scoped>
.card-title {
  font-weight: bold;
}

.select-month-year select {
  min-width: 100px;
}

.list-group-item.bg-light>div {
  font-size: 0.9rem;
}
</style>